import React from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  // RadioGroup,
  // Radio,
  // Button,
  // IconButton,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomSettings } from "subModule/src/services/invoice/types";
import { useUserLanguages } from "../hooks/useUserLanguages";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteIcon from "@mui/icons-material/Delete";

interface InspectionSettingsPanelProps {
  settings: CustomSettings;
  onChange: (settings: Partial<CustomSettings>) => void;
}

const InspectionSettingsPanel: React.FC<InspectionSettingsPanelProps> = ({
  settings,
  onChange,
}) => {
  const { t } = useTranslation();
  const { primaryLanguageName, secondaryLanguageName } = useUserLanguages();

  // const inspectionItems = settings.inspectionItems || [];

  // const addInspectionItem = () => {
  //   const newItem = {
  //     id: `item-${Date.now()}`,
  //     partName: "",
  //     status: "working" as const,
  //     notes: "",
  //   };
  //   onChange({
  //     inspectionItems: [...inspectionItems, newItem],
  //   });
  // };

  // const removeInspectionItem = (index: number) => {
  //   const updated = inspectionItems.filter((_, i) => i !== index);
  //   onChange({ inspectionItems: updated });
  // };

  // const updateInspectionItem = (index: number, field: string, value: any) => {
  //   const updated = [...inspectionItems];
  //   updated[index] = {
  //     ...updated[index],
  //     [field]: value,
  //   };
  //   onChange({ inspectionItems: updated });
  // };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {/* Show Inspection Items */}
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={settings.showInspectionItems ?? true}
            onChange={(e) => onChange({ showInspectionItems: e.target.checked })}
            sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c0055" } }}
          />
        }
        label={t("showInspectionItems")}
        sx={{ m: 0 }}
      />

          {/* Show Vehicle Image - Note: Vehicle image is integrated into inspectionItems section */}
          {settings.showInspectionItems && (
            <>
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    checked={settings.showVehicleImage ?? true}
                    onChange={(e) => onChange({ showVehicleImage: e.target.checked })}
                    sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c0055" } }}
                  />
                }
                label={t("showVehicleImage")}
                sx={{ m: 0 }}
              />
              <Typography variant="caption" color="textSecondary" sx={{ ml: 4, mb: 1 }}>
                {t("vehicleImageNote") || "Vehicle image will appear on the right side of the services table"}
              </Typography>

          {/* Show Inspection Remarks */}
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={settings.showInspectionRemarks ?? true}
                onChange={(e) =>
                  onChange({ showInspectionRemarks: e.target.checked })
                }
                sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c0055" } }}
              />
            }
            label={t("showInspectionRemarks")}
            sx={{ m: 0 }}
          />

          {/* Inspection Remarks Label */}
          {(settings.showInspectionRemarks ?? true) && (
            <Box>
              <label
                className="font-Saira font-[600] text-[13px] mb-2 block"
                style={{ color: "#333" }}
              >
                {t("inspectionRemarksLabel")}
              </label>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  mt: 1,
                }}
              >
                <TextField
                  size="small"
                  label={primaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={primaryLanguageName}
                  title={primaryLanguageName}
                  value={settings.inspectionRemarksLabel?.primary || ""}
                  onChange={(e) =>
                    onChange({
                      inspectionRemarksLabel: {
                        ...settings.inspectionRemarksLabel,
                        primary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
                <TextField
                  size="small"
                  label={secondaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={secondaryLanguageName}
                  title={secondaryLanguageName}
                  value={settings.inspectionRemarksLabel?.secondary || ""}
                  onChange={(e) =>
                    onChange({
                      inspectionRemarksLabel: {
                        ...settings.inspectionRemarksLabel,
                        secondary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
              </Box>
            </Box>
          )}

          {/* Show Technicians */}
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={settings.showTechnicians ?? true}
                onChange={(e) =>
                  onChange({ showTechnicians: e.target.checked })
                }
                sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c0055" } }}
              />
            }
            label={t("showTechnicians")}
            sx={{ m: 0 }}
          />

          {/* Technicians Label */}
          {(settings.showTechnicians ?? true) && (
            <Box>
              <label
                className="font-Saira font-[600] text-[13px] mb-2 block"
                style={{ color: "#333" }}
              >
                {t("inspectionTechniciansLabel")}
              </label>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  mt: 1,
                }}
              >
                <TextField
                  size="small"
                  label={primaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={primaryLanguageName}
                  title={primaryLanguageName}
                  value={settings.inspectionTechniciansLabel?.primary || ""}
                  onChange={(e) =>
                    onChange({
                      inspectionTechniciansLabel: {
                        ...settings.inspectionTechniciansLabel,
                        primary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
                <TextField
                  size="small"
                  label={secondaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={secondaryLanguageName}
                  title={secondaryLanguageName}
                  value={settings.inspectionTechniciansLabel?.secondary || ""}
                  onChange={(e) =>
                    onChange({
                      inspectionTechniciansLabel: {
                        ...settings.inspectionTechniciansLabel,
                        secondary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
              </Box>
            </Box>
          )}

          {/* Show Customer Signature */}
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={settings.showCustomerSignature ?? true}
                onChange={(e) =>
                  onChange({ showCustomerSignature: e.target.checked })
                }
                sx={{ "& .MuiSwitch-switchBase.Mui-checked": { color: "#4c0055" } }}
              />
            }
            label={t("showCustomerSignature")}
            sx={{ m: 0 }}
          />

          {/* Customer Signature Label */}
          {settings.showCustomerSignature && (
            <Box>
              <label
                className="font-Saira font-[600] text-[13px] mb-2 block"
                style={{ color: "#333" }}
              >
                {t("customerSignatureLabel")}
              </label>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 1 }}>
                <TextField
                  size="small"
                  label={primaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={primaryLanguageName}
                  title={primaryLanguageName}
                  value={settings.customerSignatureLabel?.primary || ""}
                  onChange={(e) =>
                    onChange({
                      customerSignatureLabel: {
                        ...settings.customerSignatureLabel,
                        primary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
                <TextField
                  size="small"
                  label={secondaryLanguageName}
                  InputLabelProps={{ shrink: true }}
                  placeholder={secondaryLanguageName}
                  title={secondaryLanguageName}
                  value={settings.customerSignatureLabel?.secondary || ""}
                  onChange={(e) =>
                    onChange({
                      customerSignatureLabel: {
                        ...settings.customerSignatureLabel,
                        secondary: e.target.value,
                      },
                    })
                  }
                  fullWidth
                />
              </Box>
            </Box>
          )}

          {/* Inspection Items List */}
          {/* <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <label
                className="font-Saira font-[600] text-[13px]"
                style={{ color: "#333" }}
              >
                {t("inspectionItems")}
              </label>
              <Button
                size="small"
                startIcon={<AddIcon />}
                onClick={addInspectionItem}
                sx={{
                  color: "#4c0055",
                  textTransform: "none",
                }}
              >
                {t("add")}
              </Button>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {inspectionItems.map((item, index) => (
                <Box
                  key={item.id || index}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 1,
                    p: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {t("item")} {index + 1}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => removeInspectionItem(index)}
                      sx={{ color: "#d32f2f" }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <TextField
                    size="small"
                    label={t("partName")}
                    InputLabelProps={{ shrink: true }}
                    placeholder={t("partName")}
                    title={t("partName")}
                    value={item.partName || ""}
                    onChange={(e) =>
                      updateInspectionItem(index, "partName", e.target.value)
                    }
                    fullWidth
                    sx={{ mb: 1.5 }}
                  />
                  <Box sx={{ mb: 1.5 }}>
                    <label
                      className="font-Saira font-[600] text-[11px] mb-1 block"
                      style={{ color: "#333" }}
                    >
                      {t("status")}
                    </label>
                    <RadioGroup
                      row
                      value={item.status || "working"}
                      onChange={(e) =>
                        updateInspectionItem(index, "status", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="working"
                        control={
                          <Radio
                            size="small"
                            sx={{ "&.Mui-checked": { color: "#4c0055" } }}
                          />
                        }
                        label={t("working")}
                      />
                      <FormControlLabel
                        value="needRepair"
                        control={
                          <Radio
                            size="small"
                            sx={{ "&.Mui-checked": { color: "#4c0055" } }}
                          />
                        }
                        label={t("needRepair")}
                      />
                      <FormControlLabel
                        value="brokenOrMissing"
                        control={
                          <Radio
                            size="small"
                            sx={{ "&.Mui-checked": { color: "#4c0055" } }}
                          />
                        }
                        label={t("brokenOrMissing")}
                      />
                    </RadioGroup>
                  </Box>
                  <TextField
                    size="small"
                    label={t("notes")}
                    InputLabelProps={{ shrink: true }}
                    placeholder={t("notes")}
                    title={t("notes")}
                    value={item.notes || ""}
                    onChange={(e) =>
                      updateInspectionItem(index, "notes", e.target.value)
                    }
                    fullWidth
                    multiline
                    rows={2}
                  />
                </Box>
              ))}
              {inspectionItems.length === 0 && (
                <Box
                  sx={{
                    textAlign: "center",
                    py: 3,
                    color: "#999",
                    border: "1px dashed #ddd",
                    borderRadius: 1,
                  }}
                >
                  {t("noInspectionItems")}
                </Box>
              )}
            </Box>
          </Box> */}
        </>
      )}
    </Box>
  );
};

export default InspectionSettingsPanel;

